var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1724,
    cy: 31.1724,
    r: 31.1724,
    fill: "#CFFFE5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_144",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 15,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3447,
    y: 15.1724,
    width: 31.1724,
    height: 31.1724,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5401 41.1493C20.8257 41.1493 20.2142 40.8949 19.7055 40.3862C19.1967 39.8775 18.9424 39.266 18.9424 38.5516V22.9654C18.9424 22.251 19.1967 21.6395 19.7055 21.1308C20.2142 20.622 20.8257 20.3677 21.5401 20.3677H42.3217C43.0361 20.3677 43.6476 20.622 44.1563 21.1308C44.665 21.6395 44.9194 22.251 44.9194 22.9654V38.5516C44.9194 39.266 44.665 39.8775 44.1563 40.3862C43.6476 40.8949 43.0361 41.1493 42.3217 41.1493H21.5401ZM31.9309 32.0573L42.3217 25.5631V22.9654L31.9309 29.4596L21.5401 22.9654V25.5631L31.9309 32.0573Z",
    fill: "#29945B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3bb2913f41180485c6fda90b0f1ab7a0.svg";
export { ForwardRef as ReactComponent };